module.exports = __webpack_public_path__ + "static/desktop/img/alipay.e245878d.png";